import { RootState } from 'store'

export const supportSelectors = {
  selectTab: (state: RootState) => state.support.tab,
  selectChats: (state: RootState) => state.support.chats,
  selectActiveChat: (state: RootState) => state.support.activeChat,
  selectMessages: (state: RootState) => state.support.messages,
  selectCounters: (state: RootState) => state.support.counters,
  selectTotalUnread: (state: RootState) => state.support.counters.total,
  selectHasMoreChats: (state: RootState) => state.support.hasMoreChats,
  selectIsChatsLoading: (state: RootState) => state.support.isChatsLoading,
  selectIsMessagesLoading: (state: RootState) => state.support.isMessagesLoading
}
